import ApiService from '../../components/api_services/apiService.jsx';

import { ReactComponent as Edit } from '../../components/icons/edit.svg';
import { ReactComponent as Trash } from '../../components/icons/trash.svg';

import { toggleNeedRefresh, toggleCheckedItem, toggleEditModal, setPage, to, setSortListEndpoint } from '../../store/notificartionsTabSlice.js';

import ClasicArrowDown from '../../components/icons/clasic-arrow-down.jsx';
import ClasicArrowUp from '../../components/icons/clasic-arrow-up.jsx';
import store from '../../store/store.js';


export const fetchNotifications = async (sortBy, sortDirection, keyword, currentPage, dispatch, setMaxPages, setRows, checkedItems ) => {
  try {
    const checkedSortBy = sortBy === null || sortDirection === null ? null : sortBy;
    const checkedSortDirection = sortBy === null || sortDirection === null ? null : sortDirection;
    const response = await ApiService.getNotifications(checkedSortBy, checkedSortDirection, keyword, currentPage);
    console.log('Odpowiedź z API:', response);

    dispatch(setMaxPages(response.maxPage)); // Ustawienie maksymalnej liczby stron na podstawie danych z API

    // Mapowanie danych z API do formatu zgodnego z tabelą
    const mappedRows = response.data.map((notification, index) => [
      <input
        type="checkbox"
        checked={checkedItems.includes(notification[0])} // Sprawdzenie, czy id znajduje się w checkedItems
        onChange={() => dispatch(toggleCheckedItem(notification[0]))} // Dodanie/Usunięcie id z listy
      />,
      notification[0], // ID
      notification[5],
      notification[2],
      notification[1],
      notification[7] === 'MALE' ? "Mężczyzna" : notification[7] ==='FEMALE' ? "Kobieta" : "",
      notification[6] === 'MALE' ? "Mężczyzna" : notification[6] ==='FEMALE' ? "Kobieta" : "",
      notification[3] ? 'Aktywny' : 'Nieaktywny',
      notification[4] ? 'Aktywny' : 'Nieaktywny',
      <div>
        <Edit
          className="menu-icon"
          onClick={() => dispatch(toggleEditModal({
            id: notification[0],
            notification_type: notification[5],
            content_pl: notification[1],
            content_eng: notification[2],
            gender_of_the_sender: notification[7],
            gender_of_the_recipient: notification[6],
            push_enabled: notification[3],
            enabled: notification[4]
          }))}
          />
        <Trash className="menu-icon" onClick={
          async () => {  // dodajemy async
            try {
              await ApiService.deleteNotifByIdList(Array.of(notification[0])); // dodajemy await
              dispatch(toggleNeedRefresh());
            } catch (error) {
              console.error('Błąd podczas usuwania:', error);
            }
          }}
        />
      </div>
    ]);

    setRows(mappedRows); // Ustawienie wierszy w stanie
    let actualPage = store.getState().notifications.currentPage;
    keyword && currentPage !== 1 && dispatch(setPage(1)); // Resetowanie strony przy wyszukiwaniu
  } catch (error) {
    console.error('Błąd podczas pobierania danych:', error);
  }
};